import script from "./MCPSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./MCPSettings.vue?vue&type=script&setup=true&lang=js"

import "./MCPSettings.vue?vue&type=style&index=0&id=d261c32e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d261c32e"]])

export default __exports__